// removed by extract-text-webpack-plugin
module.exports = {"utility-bar":"utility-bar","utility-nav":"utility-nav","utility-nav__heading":"utility-nav__heading","utility-nav__item":"utility-nav__item","current-menu-item":"current-menu-item","utility-nav__link":"utility-nav__link","current-menu-parent":"current-menu-parent","nav-toggle":"nav-toggle","prominent":"prominent","utility-nav__drop":"utility-nav__drop","utility-nav__menu":"utility-nav__menu","contact-panel":"contact-panel","hours":"hours"};


//////////////////
// WEBPACK FOOTER
// ./resources/css/scss/4-objects/_utility-nav.scss
// module id = 31
// module chunks = 0